
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojyotilingadarshancabs() {



    const cardData =
    {
        keyword: 'Pune to Jyotirling Darshan Cabs',
        heading: 'Platinum24 Cabs: Pune to Jyotirling Darshan Cabs',
        headingDescription: ' Platinum24 Cabs provides comfortable Pune to Jyotirling Darshan Cabs, making your pilgrimage to the sacred Jyotirlinga temples across Maharashtra and beyond safe and stress-free. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth journey with spacious seating and air-conditioned comfort. With professional chauffeurs experienced in religious routes, we guarantee timely darshan, convenient halts, and hassle-free travel throughout your yatra. Whether you’re visiting Bhimashankar, Trimbakeshwar, Grishneshwar, or planning an extended multi-Jyotirlinga tour, Platinum24 Cabs offers affordable packages, transparent fares, and a spiritually enriching travel experience.',

        top: 'Top Places to Visit in Jyotirling with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Somnath Jyotirlinga – Gujarat",
    "description": "Somnath Temple in Prabhas Patan, Gujarat, is the first of the 12 Jyotirlingas of Lord Shiva. Known as ‘The Eternal Shrine,’ it has been destroyed and rebuilt several times, symbolizing resilience and devotion. The temple stands majestically on the Arabian Sea coast, offering breathtaking views. Legends say Moon God worshipped Shiva here to regain his radiance. Evening aarti and light shows make it enchanting. Somnath is India’s eternal beacon of faith."
  },
  {
    "title": "Mallikarjuna Jyotirlinga – Srisailam, Andhra Pradesh",
    "description": "Mallikarjuna Jyotirlinga, located on the banks of the Krishna River in Srisailam, is revered as one of the holiest shrines. Dedicated to Lord Shiva and Goddess Parvati, it is also a Shakti Peeth. The temple’s Dravidian architecture and carvings attract pilgrims year-round. Devotees believe darshan here grants both worldly and spiritual prosperity. The scenic Nallamala Hills surround the temple. Mallikarjuna is Andhra Pradesh’s eternal abode of divine union."
  },
  {
    "title": "Mahakaleshwar Jyotirlinga – Ujjain, Madhya Pradesh",
    "description": "Mahakaleshwar Temple in Ujjain is unique as Lord Shiva here is worshipped as Swayambhu (self-manifested) Jyotirlinga. The temple is famous for its ‘Bhasma Aarti,’ performed every morning with sacred ash. It is believed darshan here removes fear of death and grants liberation. The five-tier temple includes shrines of Nagchandreshwar and Omkareshwar Mahadev. During Maha Shivratri, lakhs of devotees gather. Mahakaleshwar is Ujjain’s timeless seat of divine energy."
  },
  {
    "title": "Omkareshwar Jyotirlinga – Madhya Pradesh",
    "description": "Omkareshwar Temple is located on Mandhata Island in the Narmada River, shaped like the holy symbol ‘ॐ’ (Om). This Jyotirlinga is one of the most sacred centers of Shaivism. Pilgrims perform parikrama around the island as part of their spiritual journey. The temple is surrounded by ghats, shrines, and the serene flow of Narmada. Devotees believe darshan here brings peace and prosperity. Omkareshwar is Madhya Pradesh’s divine island of devotion."
  },
  {
    "title": "Kedarnath Jyotirlinga – Uttarakhand",
    "description": "Kedarnath, located in the Himalayas at 11,755 ft, is one of the most remote and revered Jyotirlingas. Surrounded by snow-capped peaks, the temple is accessible via a trek or helicopter. The shrine is open only for six months due to extreme weather. Pilgrims believe worship here absolves sins and grants moksha. The temple was restored after the 2013 floods, symbolizing resilience. Kedarnath is Uttarakhand’s Himalayan abode of Lord Shiva."
  },
  {
    "title": "Baidyanath Jyotirlinga – Deoghar, Jharkhand",
    "description": "Baidyanath Jyotirlinga in Deoghar is also called Vaidyanath, meaning the divine physician. It is believed Lord Shiva cured Ravana here after he offered his heads in devotion. The temple is one of the most important shrines for Kanwar Yatra pilgrims. Devotees walk for miles carrying Ganga water to offer to the lingam. Festivals like Shravan make the temple vibrant with chants. Baidyanath is Jharkhand’s healing seat of devotion."
  },
  {
    "title": "Bhimashankar Jyotirlinga – Maharashtra",
    "description": "Bhimashankar Jyotirlinga, nestled in the Sahyadri ranges near Pune, is surrounded by dense forests and wildlife. It is associated with the legend of Lord Shiva slaying the demon Tripurasura. The temple’s Nagara-style architecture adds to its charm. Pilgrims believe darshan here removes obstacles and grants spiritual upliftment. Trekkers enjoy scenic monsoon trails and waterfalls nearby. Bhimashankar is Maharashtra’s blend of divinity and nature."
  },
  {
    "title": "Kashi Vishwanath Jyotirlinga – Varanasi, Uttar Pradesh",
    "description": "Kashi Vishwanath Temple in Varanasi is one of the most famous Jyotirlingas, located on the banks of the sacred Ganga. Lord Shiva here is worshipped as Vishwanath, the ruler of the universe. A dip in the Ganga followed by darshan is believed to liberate the soul. The golden temple spire glitters with grandeur. Pilgrims from across the world consider it a must-visit. Kashi Vishwanath is India’s eternal city of spiritual enlightenment."
  },
  {
    "title": "Trimbakeshwar Jyotirlinga – Nashik, Maharashtra",
    "description": "Trimbakeshwar Jyotirlinga near Nashik is unique as the lingam represents Brahma, Vishnu, and Mahesh. It is also the origin point of the holy Godavari River. The temple is built in classic Nagara architecture using black stone. Rituals like Narayan Nagbali are performed here for ancestral peace. Devotees believe darshan brings fulfillment of desires and liberation. Trimbakeshwar is Maharashtra’s eternal Jyotirlinga of divine trinity."
  },
  {
    "title": "Nageshwar Jyotirlinga – Gujarat",
    "description": "Nageshwar Jyotirlinga, located near Dwarka in Gujarat, is dedicated to Lord Shiva as the protector from poisons. The temple houses a massive Shiva statue and the self-manifested lingam. It is believed that worship here grants protection from negative energies and serpent afflictions. The temple is peaceful yet powerful in aura. Pilgrims often combine darshan with Dwarkadhish Temple. Nageshwar is Gujarat’s coastal guardian of faith."
  },
  {
    "title": "Rameshwaram Jyotirlinga – Tamil Nadu",
    "description": "Ramanathaswamy Temple in Rameshwaram is one of the Char Dhams and a Jyotirlinga. Lord Rama is believed to have worshipped Shiva here before crossing to Lanka. The temple is famous for its 22 holy wells and the longest temple corridor in India. Pilgrims perform rituals for ancestors here. Darshan is believed to absolve sins and fulfill wishes. Rameshwaram is Tamil Nadu’s sacred coastal Jyotirlinga of devotion."
  },
  {
    "title": "Grishneshwar Jyotirlinga – Aurangabad, Maharashtra",
    "description": "Grishneshwar Jyotirlinga near Ellora Caves is the last among the 12 Jyotirlingas. Rebuilt by Ahilyabai Holkar, it reflects exquisite temple architecture. The lingam is worshipped as the Lord of Compassion. Pilgrims believe darshan here grants peace and moksha. Its proximity to Ellora makes it a spiritual and heritage destination. Grishneshwar is Maharashtra’s sacred shrine of grace and devotion."
  }
],



        "services": [
    {
      "name": "Pune to Jyotirling Darshan Taxi",
      "description": "Spiritual and convenient taxi service for Jyotirling Darshan tours from Pune. Visit sacred Jyotirlingas like Trimbakeshwar, Bhimashankar, Grishneshwar, and more with comfortable cabs, experienced drivers, and timely schedules tailored for pilgrimage."
    },
    {
      "name": "Jyotirling Darshan Cab Booking Pune",
      "description": "Instant online booking for Jyotirling Darshan cabs from Pune with flexible pickup points and a variety of vehicles including sedans, SUVs, and tempo travellers. Ideal for family, group, and solo pilgrimages."
    },
    {
      "name": "Pune Jyotirling Darshan Cabs",
      "description": "Dedicated cab services from Pune for Jyotirling Darshan, offering multi-day packages to cover major Jyotirling temples across Maharashtra and India. Comfortable travel and driver assistance included."
    },
    {
      "name": "Taxi for Jyotirling Darshan Pune",
      "description": "Reliable and well-maintained taxis for spiritual journeys to Jyotirling temples. All taxis come with GPS, experienced drivers, and customizable itineraries for religious travel from Pune."
    },
    {
      "name": "Pune to Jyotirling Car Rental",
      "description": "Chauffeur-driven and self-drive car rental options for Jyotirling Darshan trips from Pune. Choose from hatchbacks to luxury vehicles for a devotional yet comfortable experience."
    },
    {
      "name": "Jyotirling Pilgrimage Taxi Pune",
      "description": "Special pilgrimage taxi service for Jyotirling Darshan from Pune, covering Trimbakeshwar, Bhimashankar, Aundha Nagnath, Parli Vaijnath, and other major shrines with experienced guides and comfortable cars."
    },
    {
      "name": "Affordable Jyotirling Tour Cabs Pune",
      "description": "Budget-friendly cab packages for Jyotirling Darshan starting from Pune. Options include per-kilometer rates, fixed multi-day plans, and all-inclusive pricing with no hidden charges."
    },
    {
      "name": "Pune Jyotirling Private Taxi",
      "description": "Hire a private taxi for personalized Jyotirling tours from Pune. Get privacy, flexibility in darshan timings, and route customization with local driver knowledge."
    },
    {
      "name": "Pune to Jyotirling Taxi Fare",
      "description": "Transparent and detailed fare structure for Jyotirling cab services from Pune. View pricing for each route and car type, including distance-wise and day-wise billing options."
    },
    {
      "name": "Jyotirling Taxi Packages Pune",
      "description": "Specialized Jyotirling Darshan cab packages from Pune including temple visits, overnight stays, and sightseeing. Suitable for senior citizens, families, and devotional tour groups."
    },
    {
      "name": "Pune Jyotirling One Way Taxi",
      "description": "One-way taxi service from Pune to any Jyotirling temple such as Bhimashankar, Trimbakeshwar, or Grishneshwar. Cost-effective and ideal for short trips or one-leg journeys."
    },
    {
      "name": "Taxi Service Pune to Jyotirling",
      "description": "Round-the-clock taxi services from Pune for Jyotirling Darshan with verified drivers, clean cabs, and devotional-friendly support. Pickup from any location in Pune available."
    },
    {
      "name": "Jyotirling Taxi with Driver Pune",
      "description": "Hire a taxi with professional and courteous driver for Jyotirling temple visits from Pune. Drivers are trained to assist elderly travelers and know temple schedules and best routes."
    },
    {
      "name": "Pune to Jyotirling Darshan Cab Charges",
      "description": "Know detailed cab charges from Pune for Jyotirling tours. Fares include driver charges, fuel, toll, and parking. Get custom quotes based on trip duration and vehicle category."
    },
    {
      "name": "Jyotirling Darshan Cab Service Pune",
      "description": "All-in-one cab service for Jyotirling Darshan from Pune, including round trips, one-way drops, and multi-day religious circuits. Comfortable cabs with spiritual tour guidance."
    }
  ],
  "tableData": [
    ["Pune to Jyotirling Darshan Taxi", "Jyotirling Darshan Cab Booking Pune"],
    ["Pune Jyotirling Darshan Cabs", "Taxi for Jyotirling Darshan Pune"],
    ["Pune to Jyotirling Car Rental", "Jyotirling Pilgrimage Taxi Pune"],
    ["Affordable Jyotirling Tour Cabs Pune", "Pune Jyotirling Private Taxi"],
    ["Pune to Jyotirling Taxi Fare", "Jyotirling Taxi Packages Pune"],
    ["Pune Jyotirling One Way Taxi", "Taxi Service Pune to Jyotirling"],
    ["Jyotirling Taxi with Driver Pune", "Pune to Jyotirling Darshan Cab Charges"],
    ["Jyotirling Darshan Cab Service Pune", "—"]
  ],


           "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Jyotirling Darshan Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers comfortable and trustworthy cab rides for your Jyotirling pilgrimage from Pune."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Jyotirling Routes",
      "WhyChoosedescription": "Our skilled drivers know the best paths to ensure a safe and timely spiritual journey."
    },
    {
      "WhyChooseheading": "Spacious and Sanitized Vehicles for Group Travel",
      "WhyChoosedescription": "Travel comfortably in clean, air-conditioned cabs with ample space for passengers and luggage."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trips",
      "WhyChoosedescription": "Choose packages tailored to your pilgrimage schedule and preferences."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing including fuel, tolls, and driver allowances for hassle-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Bookings",
      "WhyChoosedescription": "Our dedicated team is available round the clock to assist with your booking needs and special requests."
    },
    {
      "WhyChooseheading": "Ideal for Family, Group, and Spiritual Tours",
      "WhyChoosedescription": "Our Pune to Jyotirling cab services are perfect for all travelers seeking a spiritual experience."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers depending on your travel needs."
    }
  ]




































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services from Pune for Jyotirling Darshan?',
        answer: 'Yes, Platinum24 Cabs provides comfortable and reliable cab services for Jyotirling Darshan tours starting from Pune.',
    },
    {
        question: 'How can I book a Pune to Jyotirling Darshan cab with Platinum24 Cabs?',
        answer: 'You can book your cab easily through our website, mobile app, or by calling our customer support team for personalized assistance.',
    },
    {
        question: 'Which Jyotirling destinations can be covered from Pune?',
        answer: 'Popular Jyotirling routes from Pune include Bhimashankar, Trimbakeshwar, Grishneshwar, and other Jyotirling temples as per your itinerary.',
    },
    {
        question: 'What types of vehicles are available for Jyotirling Darshan from Pune?',
        answer: 'We offer a range of vehicles including sedans, SUVs, tempo travellers, and luxury cars based on your group size and travel preferences.',
    },
    {
        question: 'Are drivers familiar with the Jyotirling routes from Pune?',
        answer: 'Yes, our drivers are experienced and well-acquainted with the pilgrimage routes and temple locations for a smooth journey.',
    },
    {
        question: 'Can I book a multi-day Jyotirling Darshan cab package from Pune?',
        answer: 'Absolutely! We provide customizable multi-day rental packages ideal for covering multiple Jyotirling temples.',
    },
    {
        question: 'What is included in the Pune to Jyotirling Darshan cab fare?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Extra charges may apply for additional detours or waiting time.',
    },
    {
        question: 'Can I customize the pickup and drop-off locations for Jyotirling Darshan?',
        answer: 'Yes, you can specify preferred pickup/drop-off points in Pune or en route Jyotirling destinations as per your plan.',
    },
    {
        question: 'Are safety and hygiene measures ensured during Jyotirling Darshan trips?',
        answer: 'Yes, all our cabs are sanitized regularly, and our drivers follow strict hygiene and safety protocols throughout the journey.',
    },
    {
        question: 'Does Platinum24 Cabs offer corporate pilgrimage tours for Jyotirling Darshan?',
        answer: 'Yes, we provide tailored solutions for corporate and group bookings with priority support and flexible billing options.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Prakash Jadhav',
        feedback: 'We booked a cab from Pune for the Jyotirling Darshan tour. The service was excellent and the driver guided us well throughout.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Mrs. Anuja Desai',
        feedback: 'Our multi-day Jyotirling trip with Platinum24 Cabs was smooth and spiritually fulfilling. Highly recommend their services!',
        rating: 5,
    },
];













































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneToJyotirlingSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jyotirling Darshan Cab",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-jyotirling-darshan-cab.jpg",
  "description": "Book Pune to Jyotirling Darshan cabs with Platinum24 Cabs. Comfortable and reliable taxi services for Jyotirling pilgrimage tours with experienced drivers and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-jyotirling-darshan-cab"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Jyotirling Darshan Cabs | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Reliable Pune to Jyotirling Darshan taxi service by Platinum24 Cabs. Book AC cabs for Jyotirling pilgrimage tours with experienced drivers and competitive pricing."
  />
  <meta
    name="keywords"
    content="Pune to Jyotirling Darshan Taxi, Jyotirling Darshan Cab Booking Pune, Pune Jyotirling Darshan Cabs, Taxi for Jyotirling Darshan Pune, Pune to Jyotirling Car Rental, Jyotirling Pilgrimage Taxi Pune, Affordable Jyotirling Tour Cabs Pune, Pune Jyotirling Private Taxi, Pune to Jyotirling Taxi Fare, Jyotirling Taxi Packages Pune, Pune Jyotirling One Way Taxi, Taxi Service Pune to Jyotirling, Jyotirling Taxi with Driver Pune, Pune to Jyotirling Darshan Cab Charges, Jyotirling Darshan Cab Service Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToJyotirlingSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/40.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetojyotilingadarshancabs;